module.exports = __webpack_public_path__ + "static/media/YM79_2.d44ee4c8.jpg";